"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
exports.__esModule = true;
exports.TranslatorConsumer = exports.useTranslator = exports.TranslatorProvider = void 0;
var React = __importStar(require("react"));
var core_1 = require("@translator-app/core");
var TranslatorContext = React.createContext({});
function versionReducer(state, action) {
    switch (action.type) {
        case 'increment':
            return { version: state.version + 1 };
        default:
            return state;
    }
}
function TranslatorProvider(props) {
    var children = props.children, library = props.library, language = props.language, fallbackLanguage = props.fallbackLanguage, getTranslationRegistry = props.getTranslationRegistry;
    var translatorInstance = React.useState(function () {
        return core_1.translator({
            fallbackLanguage: fallbackLanguage || language,
            library: library
        });
    })[0];
    var _a = React.useReducer(versionReducer, { version: 0 }), registryVersion = _a[0], dispatchVersionChange = _a[1];
    React.useEffect(function () {
        if (getTranslationRegistry && !translatorInstance.hasLanguage(language)) {
            var result = getTranslationRegistry(language);
            var update = function (newRegistry) {
                if (!newRegistry) {
                    return;
                }
                translatorInstance.addLanguage(language, newRegistry);
                dispatchVersionChange({ type: 'increment' });
            };
            if (result instanceof Promise) {
                result.then(update);
            }
            else {
                update(result);
            }
        }
    }, [language]);
    var getTranslation = function (key, values) {
        var translation = translatorInstance.translate({ key: key, values: values, language: language });
        return translation.value;
    };
    var providerValues = {
        language: language,
        translate: getTranslation,
        version: registryVersion.version
    };
    return React.createElement(TranslatorContext.Provider, { value: providerValues }, children);
}
exports.TranslatorProvider = TranslatorProvider;
exports.useTranslator = function () { return React.useContext(TranslatorContext); };
exports.TranslatorConsumer = TranslatorContext.Consumer;
//# sourceMappingURL=index.js.map